import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './gallery.css';
import { Link } from "react-router-dom";

class Gallery extends Component {

    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    updatePopUp = (n) => {
        let PopUpSrc;
        switch (n) {
            case "1": PopUpSrc = "/image/gallery/enlargedPhotos/360_Photo-22.jpg"; break;
            case "2": PopUpSrc = "/image/gallery/enlargedPhotos/311_Photo-176.jpg"; break;
            case "3": PopUpSrc = "/image/gallery/enlargedPhotos/323_DSC05594.jpg"; break;
            case "4": PopUpSrc = "/image/gallery/enlargedPhotos/349_IMG_6822.jpg"; break;
            case "5": PopUpSrc = "/image/gallery/enlargedPhotos/BIG 150 20211207EMSD0063.JPG"; break;
            case "6": PopUpSrc = "/image/gallery/enlargedPhotos/302 20211207EMSD0561.JPG"; break;
            case "7": PopUpSrc = "/image/gallery/enlargedPhotos/258 20211207EMSD0503.JPG"; break;
            case "8": PopUpSrc = "/image/gallery/enlargedPhotos/335 20211207EMSD0591.jpg"; break;
            case "9": PopUpSrc = "/image/gallery/enlargedPhotos/_39I2504.JPG"; break;
            case "10": PopUpSrc = "/image/gallery/enlargedPhotos/_39I2249.JPG"; break;
            case "11": PopUpSrc = "/image/gallery/enlargedPhotos/_39I2479.JPG"; break;
            case "12": PopUpSrc = "/image/gallery/enlargedPhotos/newly added_39I2541.JPG"; break;
            case "13": PopUpSrc = "/image/gallery/enlargedPhotos/Big-100 IMG_4912 (1).jpg"; break;
            case "14": PopUpSrc = "/image/gallery/enlargedPhotos/small-215 IMG_5030.jpg"; break;
            case "15": PopUpSrc = "/image/gallery/enlargedPhotos/small-497 JH9A0094.jpg"; break;
            case "16": PopUpSrc = "/image/gallery/enlargedPhotos/small-472 IMG_5211.jpg"; break;
            default: PopUpSrc = ""; break;
        }
        let modalImg = document.getElementById('gallery-image-popup');
        modalImg.setAttribute('src', PopUpSrc);
        if(n==="1"){
            modalImg.closest(".modal-dialog").classList.remove("modal-dialog-xl");
            modalImg.closest(".modal-dialog").classList.add("modal-dialog-sp");
        }else{
            modalImg.closest(".modal-dialog").classList.remove("modal-dialog-sp");
            modalImg.closest(".modal-dialog").classList.add("modal-dialog-xl");
        }
    }
    render() {
        const { t } = this.props;
        let path = window.location.pathname
        let match = path.slice(0, 3);
    
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('gallery-meta-title')}</title>
                    <meta name="title" content={t('gallery-meta-title')} />
                    <meta name="description" content={t('gallery-meta-description')} />
                    <meta name="keywords" content={t('gallery-meta-keywords')} />
                </MetaTags>
                <div id="div-gallery">
                    <div className="gallery-banner">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="gallery-banner-text text-center"><strong>{t('gallery-banner-text')}</strong></div>
                        </div>
                    </div>
                    <div className="gallery-video"><video autoPlay loop muted playsInline controls id="galleryVideo" src="https://storage.googleapis.com/emsd_video/211012%20-%20HKSTP%20Highlight%20V4.mp4" type="video/mp4" ></video></div>
                    <div className="gallery-section">
                        <div className="gallery-headline-text text-center"><strong>{t('gallery-headline-1')}</strong></div>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-conf-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('1')}></div>
                                <div className="d-md-flex">
                                    <div className="gallery-conf-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('2')}></div>
                                    <div className="gallery-conf-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('3')}></div>
                                    <div className="gallery-conf-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('4')}></div>
                                </div>
                                <div className="d-flex justify-content-center">
                                <Link className="nav-link no_border" aria-current="page" to={match + "/gallery-conference"}onClick={() => this.goToTop()}><button className="btn_see">
                                        <strong>{t('btn-see-more')}</strong>
                                    </button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-section">
                        <div className="gallery-headline-text text-center"><strong>{t('gallery-headline-2')}</strong></div>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-workshop-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('5')}></div>
                                <div className="d-md-flex">
                                    <div className="gallery-workshop-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('6')}></div>
                                    <div className="gallery-workshop-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('7')}></div>
                                    <div className="gallery-workshop-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('8')}></div>
                                </div>
                                <div className="d-flex justify-content-center">
                                <Link className="nav-link no_border" aria-current="page" to={match + "/gallery-workshop"}onClick={() => this.goToTop()}><button className="btn_see">
                                        <strong>{t('btn-see-more')}</strong>
                                    </button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-section">
                        <div className="gallery-headline-text text-center"><strong>{t('gallery-headline-3')}</strong></div>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-meeting-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('9')}></div>
                                <div className="d-md-flex">
                                    <div className="gallery-meeting-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('10')}></div>
                                    <div className="gallery-meeting-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('11')}></div>
                                    <div className="gallery-meeting-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('12')}></div>
                                </div>
                                <div className="d-flex justify-content-center">
                                <Link className="nav-link no_border" aria-current="page" to={match + "/gallery-meeting"}onClick={() => this.goToTop()}><button className="btn_see">
                                        <strong>{t('btn-see-more')}</strong>
                                    </button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-section">
                        <div className="gallery-headline-text text-center"><strong>{t('gallery-headline-4')}</strong></div>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-award-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('13')}></div>
                                <div className="d-md-flex">
                                    <div className="gallery-award-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('14')}></div>
                                    <div className="gallery-award-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('15')}></div>
                                    <div className="gallery-award-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('16')}></div>
                                </div>
                                <div className="d-flex justify-content-center">
                                <Link className="nav-link no_border" aria-current="page" to={match + "/gallery-awards"}onClick={() => this.goToTop()}><button className="btn_see">
                                        <strong>{t('btn-see-more')}</strong>
                                    </button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="gallery-image-modal" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <img className="modal-content" id="gallery-image-popup" src="" alt="" />
                        </div>
                    </div>

                    <Footer />
                </div>
            </div >
        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Gallery);



// WEBPACK FOOTER //
// ./src/components/pages/gallery.js